import { EuiSpacer } from '@elastic/eui';
import SuccessBox from 'components/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/SuccessBox';
import PermissionBox from 'components/Web_User_Interface/1440p_Series/_permissions/MultimediaLivestreamPerm';
import PrivacyTable from 'components/Web_User_Interface/1440p_Series/Multimedia/Privacy_Mask/privacyTable';
import BreadCrumbs from 'components/Layout/BreadCrumbs';
import SEOHelmet from 'components/Layout/SEOHelmet';
import * as React from 'react';
export default {
  EuiSpacer,
  SuccessBox,
  PermissionBox,
  PrivacyTable,
  BreadCrumbs,
  SEOHelmet,
  React
};